import { useNavigate } from "react-router-dom";
import { Box, Button, Card, Stack, Typography } from "@mui/material";
import dojo from "../../images/dojo1.jpg";
import homa from "../../images/logo-homa-bjj.svg";
import {
  HOME_PAGE_PRIMARY_TEXT,
  HOME_PAGE_QUESTION,
  HOME_PAGE_SECONDARY_TEXT,
  HOME_PAGE_TITLE,
} from "./shared";

const STAT_TILES = [
  { label: "265$ / 3 mois", detail: "Nouveaux membres" },
  { label: "Gi Gratuit", detail: "Inclus à l'inscription" },
  { label: "Tous niveaux", detail: "Débutant à avancé" },
];

export function HomePage() {
  const navigate = useNavigate();

  const goToClasses = () => {
    navigate("/cours");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          height: { xs: "70vh", md: "85vh" },
          clipPath: { md: "polygon(0 0, 100% 0, 100% 82%, 0 100%)" },
        }}
      >
        <Box
          component="img"
          src={dojo}
          alt="La salle d'entraînement de Volt BJJ à Longueuil"
          sx={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        <Box
          sx={{ position: "absolute", inset: 0, backgroundColor: "rgba(0,0,0,0.35)" }}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            px: { xs: 3, md: 10 },
            gap: 3,
          }}
        >
          <Typography variant="h2" sx={{ color: "#fff", maxWidth: 800 }}>
            {HOME_PAGE_TITLE}
          </Typography>
          <Button variant="contained" size="large" onClick={goToClasses}>
            Voir nos cours
          </Button>
        </Box>
      </Box>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        sx={{ mt: { xs: -3, md: -6 }, position: "relative", zIndex: 1, px: { xs: 2, md: 6 } }}
        spacing={2}
      >
        {STAT_TILES.map((tile) => (
          <Card
            key={tile.label}
            sx={{ flex: 1, p: 3, backgroundColor: "#d40000", color: "#ffffff" }}
          >
            <Typography variant="h5">{tile.label}</Typography>
            <Typography variant="body2">{tile.detail}</Typography>
          </Card>
        ))}
      </Stack>

      <Box sx={{ display: "flex", justifyContent: "center", px: 2, py: 6 }}>
        <Card
          sx={{
            maxWidth: 800,
            p: { xs: 3, md: 5 },
            border: "2px solid",
            borderColor: "#d40000",
          }}
        >
          <Typography variant="h5" gutterBottom sx={{ color: "#ffffff" }}>
            {HOME_PAGE_QUESTION}
          </Typography>
          <Typography variant="body1" sx={{ color: "#ffffff" }}>
            {HOME_PAGE_PRIMARY_TEXT}
          </Typography>
          <br />
          <Typography variant="body1" sx={{ color: "#ffffff" }}>
            {HOME_PAGE_SECONDARY_TEXT}
          </Typography>
        </Card>
      </Box>

      <Stack direction="row" justifyContent="center" alignItems="center" spacing={1} pb={4}>
        <Typography variant="body2" color="text.secondary">
          Affilié à
        </Typography>
        <Box
          component="img"
          src={homa}
          alt="Homa BJJ"
          width={160}
          sx={{ cursor: "pointer" }}
          onClick={() => window.open("https://homabjj.com", "_blank")}
        />
      </Stack>
    </Box>
  );
}
